import React from 'react';
import Steps from './Steps';

function HistoryLogAlert(props){

    return (
        <div className="box">
            <div className="boxTitle">History Log</div>
            <div className="boxContent">
                <Steps historyLogs={props.historyLogs} />
            </div>
        </div>
    );
}

export default HistoryLogAlert;